import { useState, useEffect, useCallback } from 'react'

export default function useInfo({
  id,
  requestInfo,
  requestUpdate,
  requestDestroy,
}) {
  const [info, setInfo] = useState({ attributes: {} })
  const [loading, setLoading] = useState(true)
  const [updating, setUpdating] = useState(false)
  const [deleting, setDeleting] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [responseError, setResponseError] = useState({})

  const getInfo = useCallback(async () => {
    setLoading(true)
    setProcessing(true)
    const response = await requestInfo(id)

    setLoading(false)
    setProcessing(false)
    if (response.error) {
      return setResponseError(response.error)
    }

    return setInfo(response.data)
  }, [requestInfo, id])

  useEffect(() => {
    getInfo()
  }, [getInfo])

  const update = async (params) => {
    setUpdating(true)
    setProcessing(true)

    const response = await requestUpdate(id, params)
    setUpdating(false)
    setProcessing(false)

    if (response.error) setResponseError(response)

    return setInfo(response.data)
  }

  const destroy = async () => {
    setDeleting(true)
    setProcessing(true)

    const response = await requestDestroy(id)
    setDeleting(false)
    setProcessing(false)

    if (response.error) {
      setResponseError(response)
      return false
    }

    return true
  }

  return [
    info,
    {
      loading,
      updating,
      deleting,
      processing,
      responseError,
    },
    {
      update,
      destroy,
      getInfo,
    },
  ]
}
